// Generated by purs version 0.13.8
"use strict";
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var valueText = Halogen_HTML_Properties.attr("aria-valuetext");
var valueNow = Halogen_HTML_Properties.attr("aria-valuenow");
var valueMin = Halogen_HTML_Properties.attr("aria-valuemin");
var valueMax = Halogen_HTML_Properties.attr("aria-valuemax");
var sort = Halogen_HTML_Properties.attr("aria-sort");
var setSize = Halogen_HTML_Properties.attr("aria-setsize");
var selected = Halogen_HTML_Properties.attr("aria-selected");
var role = Halogen_HTML_Properties.attr("role");
var required = Halogen_HTML_Properties.attr("aria-required");
var relevant = Halogen_HTML_Properties.attr("aria-relevant");
var readOnly = Halogen_HTML_Properties.attr("aria-readonly");
var pressed = Halogen_HTML_Properties.attr("aria-pressed");
var posInSet = Halogen_HTML_Properties.attr("aria-posinset");
var owns = Halogen_HTML_Properties.attr("aria-owns");
var orientation = Halogen_HTML_Properties.attr("aria-orientation");
var multiSelectable = Halogen_HTML_Properties.attr("aria-multiselectable");
var multiLine = Halogen_HTML_Properties.attr("aria-multiline");
var live = Halogen_HTML_Properties.attr("aria-live");
var level = Halogen_HTML_Properties.attr("aria-level");
var labelledBy = Halogen_HTML_Properties.attr("aria-labelledby");
var label = Halogen_HTML_Properties.attr("aria-label");
var invalid = Halogen_HTML_Properties.attr("aria-invalid");
var hidden = Halogen_HTML_Properties.attr("aria-hidden");
var hasPopup = Halogen_HTML_Properties.attr("aria-haspopup");
var grabbed = Halogen_HTML_Properties.attr("aria-grabbed");
var flowTo = Halogen_HTML_Properties.attr("aria-flowto");
var expanded = Halogen_HTML_Properties.attr("aria-expanded");
var dropEffect = Halogen_HTML_Properties.attr("aria-dropeffect");
var disabled = Halogen_HTML_Properties.attr("aria-disabled");
var describedBy = Halogen_HTML_Properties.attr("aria-describedby");
var controls = Halogen_HTML_Properties.attr("aria-controls");
var checked = Halogen_HTML_Properties.attr("aria-checked");
var busy = Halogen_HTML_Properties.attr("aria-busy");
var autoComplete = Halogen_HTML_Properties.attr("aria-autocomplete");
var atomic = Halogen_HTML_Properties.attr("aria-atomic");
var activeDescendant = Halogen_HTML_Properties.attr("aria-activedescendant");
module.exports = {
    activeDescendant: activeDescendant,
    atomic: atomic,
    autoComplete: autoComplete,
    busy: busy,
    checked: checked,
    controls: controls,
    describedBy: describedBy,
    disabled: disabled,
    dropEffect: dropEffect,
    expanded: expanded,
    flowTo: flowTo,
    grabbed: grabbed,
    hasPopup: hasPopup,
    hidden: hidden,
    invalid: invalid,
    label: label,
    labelledBy: labelledBy,
    level: level,
    live: live,
    multiLine: multiLine,
    multiSelectable: multiSelectable,
    orientation: orientation,
    owns: owns,
    posInSet: posInSet,
    pressed: pressed,
    readOnly: readOnly,
    relevant: relevant,
    required: required,
    selected: selected,
    setSize: setSize,
    sort: sort,
    valueMax: valueMax,
    valueMin: valueMin,
    valueNow: valueNow,
    valueText: valueText,
    role: role
};
